<script setup lang="ts">
import PlusIcon from '@/components/common/plus-icon.vue';
import { computed } from 'vue';
import { AllowableProductModel } from '../../models/allowable-product-model.model';
import BackstageImage from '../common/BackstageImage.vue';

const props = defineProps<{
  productModel: AllowableProductModel;
}>();

const emit = defineEmits<{
  showProductModelDetailsPopup: [];
}>();

const showProductModelDetailsPopup = (event: Event) => {
  event.stopPropagation();
  emit('showProductModelDetailsPopup');
};

const getProductImage = computed(() => {
  return props.productModel.defaultImage;
});
</script>

<template>
  <article class="product-model-card" v-bind="$attrs" :class="[{ selected: productModel.selected }]">
    <div class="card-top" data-cy="card-top">
      <BackstageImage v-if="getProductImage" class="img" :src="getProductImage" alt="product image" />
    </div>
    <div class="card-bottom" data-cy="card-bottom">
      <span>{{ productModel.name }}</span>
      <PlusIcon :selected="productModel.selected"></PlusIcon>
    </div>
    <div
      v-if="productModel.defaultVariantImages"
      class="expand-image-btn"
      data-cy="image-expand-button"
      @click="($event) => showProductModelDetailsPopup($event)"></div>
  </article>
</template>

<style scoped lang="scss">
.product-model-card {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
  aspect-ratio: 172.29 / 190;
  color: var(--primary-text-color);
  background-color: var(--primary-bg-color);

  &.selected {
    outline: 2px solid var(--new-primary-color);
  }

  @media (hover) {
    &:focus {
      border: 2px solid var(--bg-remark-selected-color);
    }

    &:hover {
      background-color: var(--bg-remark-selected-color);
    }

    &:hover,
    &:focus {
      .expand-image-btn {
        display: block;
      }
    }
  }

  .card-top {
    width: 100%;
    height: 70%;

    .img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .card-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 1rem;
    padding-left: 1rem;
    width: 100%;
    gap: 1rem;

    span {
      text-align: left;
      font-size: 0.875em;
    }
  }

  .expand-image-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 24px;
    height: 24px;
    @include icon-image('@/assets/img/icons/expand.svg', var(--primary-text-color));
    @media (hover) {
      display: none;
    }
  }
}

.dark
  .products-models-selector
  .products-models-selector-cnt
  .products-models-list
  .product-model-cards
  article.product-model-card {
  background-color: var(--bg-remark-selected-color);
}
</style>
